<app-page-header [header]="'remote.verify.title'" />

<qbe-panel-component>
  <div class="page-container" [ngSwitch]="initState$ | async">
    <ng-container *ngSwitchCase="apiState.success">
      <div *ngIf="(isActive$ | async); else inactive" class="page-content-container u-text-center">
          <h2 nxHeadline="section" class="nx-margin-bottom-2m">{{ 'remote.verify.content.active.header' | translate }}</h2>
          <p nxCopytext="large" class="nx-margin-bottom-2m">{{ 'remote.verify.content.active.description' | translate:(params$ | async) }}</p>
          <button nxButton (click)="sendSmsToken()">{{ 'remote.verify.content.active.button_send' | translate }}</button>
      </div>
      <app-illustration-absolute name="clientAndAgentShakingHands" [maxWidth]="341" />
    </ng-container>
    <app-error *ngSwitchCase="apiState.error" [appError]="initError$ | async" />
    <app-loader *ngSwitchDefault />
  </div>
</qbe-panel-component>

<ng-template #inactive>
  <div class="page-content-container">
    <nx-error class="nx-margin-bottom-m">
      {{ 'remote.verify.content.inactive.error' | translate }}
    </nx-error>
    <p nxCopytext="normal">
      {{ 'remote.verify.content.inactive.description' | translate:(params$|async) }} <br/>
      <br/>
      {{ 'remote.verify.content.inactive.name' | translate }} {{ agentName$ | async }}<br/>
      {{ 'remote.verify.content.inactive.phone' | translate }} <a [href]="(agentPhone$ | async)?.link" class="md-link">{{ (agentPhone$ | async)?.text }}</a><br/>
      {{ 'remote.verify.content.inactive.email' | translate }} <a [href]="(agentEmail$ | async)?.link" class="md-link">{{ (agentEmail$ | async)?.text }}</a>
    </p>
  </div>
</ng-template>
